export default __webpack_public_path__ + "static/media/person.3d46413f.svg";